export class ErrorObj {
  userMessage: string;
  exception: any;
  showModal: boolean;
  timestamp: Date;
}
export class UserContext {
  id: any;
  username: any;
  email: any;
}
export enum TrackCategory {
  webaction = "webaction",
}
import ReactPixel from 'react-facebook-pixel';


export enum TrackEvent {
  accountCreated = "accountCreated",
  createPodCast = "createPodCast",
  editPodCast = "editPodCast",
  deletePodCast = "deletePodCast",
  createTrackRequestFromUrl = "createTrackRequestFromUrl",
  createTrackRequestFromText = "createTrackRequestFromText",
  purchaseCredits = "purchaseCredits",
  purchaseSuccess = "purchaseSuccess",
  purchaseFail = "purchaseFail",
  purchaseTrack = "purchaseTrack",
  quickPurchaseTrack = "quickPurchaseTrack",
  downloadTrackAudio = "downloadTrackAudio",
  subscribeUrlCopy = "subscribeUrlCopy",
  archiveTrack = "archiveTrack",
  changePlanPro = "changePlanPro",
  changePlanFree = "changePlanFree",
  changePlanPremium = "changePlanPremium",
}
let ReactGA = {
  pageview(e) {
    console.info(e);
  },
  modalview(e) {
    console.info(e);
  },
  set(e) {
    console.info(e);
  },
  exception(e) {
    console.error(e);
  },
  event(e) {
    console.info(e);
  }
};
let Raven = {
  setUserContext: function (e) { },
  setExtraContext: function (e) { },
  captureException: function (e) { }
};
let GitInfo = require("../track/gitinfo").default;
if (typeof window !== "undefined") {
  Raven = require("raven-js");

  /* let getCookie = function(cname) {
     var name = cname + "=";
     var decodedCookie = decodeURIComponent(document.cookie);
     var ca = decodedCookie.split(';');
     for(var i = 0; i <ca.length; i++) {
       var c = ca[i];
       while (c.charAt(0) == ' ') {
         c = c.substring(1);
       }
       if (c.indexOf(name) == 0) {
         return c.substring(name.length, c.length);
       }
     }
     return "";
   }*/
  window['stopTracking'] = function () {
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    setCookie('notrack', true, 365)
    window.location.reload();
  }


  if ((location.hostname == "localhost" && window.location.port == "3000")) {
    console.log("NOTTRACKING")
  }
  else {
    //@ts-ignore
    Raven.config("https://6ddc54a08ea44a19ba51256d0063a4c8@sentry.io/1417017", {
      release: GitInfo.VERSION
    }).install();

  }

  //const advancedMatching = { em: 'some@email.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
  const options = {
    autoConfig: true, 	// set pixel's autoConfig
    debug: false, 		// enable logs
  };
  ReactPixel.init('293616634519686', {}, options);
  /*
 ReactPixel.pageView(); 					// For tracking page view
 ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
 ReactPixel.trackCustom( event, data ) */
  ReactGA = require("react-ga");

  //@ts-ignore
  ReactGA.initialize("UA-92222572-6", "auto", {
    allowLinker: true
  });
  ReactGA["ga"]("require", "linker");
  ReactGA.exception = err => {
    Raven.captureException(err);
    ReactGA["ga"]("send", "exception", {
      exDescription: err.userMessage ? err.userMessage : err.exception.message,
      exRawMessage: err.exception.message,
      exFatal: false
    }).bind(ReactGA);
  };
  // }
}
export class Track {
  static onError: any;
  static Init(onError: any) {
    Track.onError = onError;


  }
  static PageView(page) {

    ReactGA.pageview(page);
  }
  static ModelView(modalName) {
    ReactGA.modalview(modalName);
  }
  static SetUserContext(user: UserContext) {

    Track.SetDimension({
      email: user.username,
      userId: user.username,
      firebaseUid: user.id
    });
    Raven.setUserContext(user);
  }
  static SetDimension(obj) {
    ReactGA.set(obj);

    try {
      //@ts-ignore
      ga('set', 'userId', obj.userId);
    }
    catch (e) {
      console.error('cound not set userid')
    }
    //@ts-ignore

    Raven.setExtraContext(obj);
  }
  static Event(category: TrackCategory, type: TrackEvent) {
    ReactGA.event({
      category: TrackCategory[category],
      action: TrackEvent[type]
    });
    if (type == TrackEvent.accountCreated) {
      ReactPixel.trackCustom('StartTrial', {})
      console.log('track facebook pixel')
    }
  }
  static EventString(category: TrackCategory, text: string) {
    ReactGA.event({
      category: TrackCategory[category],
      action: text
    });
  }

  static reportError(
    exception: any,
    userMessage: string,
    showModal: boolean,
    dispatch?: any
  ) {
    Track.error(exception);
    try {
      let err = new ErrorObj();
      err.exception = exception;
      err.showModal = showModal;
      err.userMessage = userMessage;

      //@ts-ignore
      ReactGA.exception(err);

      if (dispatch) {
        err.timestamp = err.timestamp ? err.timestamp : new Date();
        if (Track.onError) dispatch(Track.onError(err));
      }
    } catch (e) { console.error(e) }
  }
  private static consoleLog(type, value) {
    try {
      return console[`${type}_old`]
        ? console[`${type}_old`](value)
        : console[type](value);
    } catch (e) {
      console.error(e);
    }
  }
  static debug(value) {
    return Track.consoleLog("debug", value);
  }
  static log(value) {
    return Track.consoleLog("log", value);
  }
  static warn(value) {
    return Track.consoleLog("warn", value);
  }
  static error(value) {
    return Track.consoleLog("error", value);
  }
  static info(value) {
    return Track.consoleLog("info", value);
  }
}



// WEBPACK FOOTER //
// ./src/data/track/track.ts